import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function News() {
  const [activeCategory, setActiveCategory] = useState('All');

  const categories = ['All', 'Discoveries', 'Sustainability', 'Technology', 'Company News'];

  const articles = [
    {
      title: 'Alphaden Announces Major Gas Discovery in Zambezi Basin',
      category: 'Discoveries',
      date: 'March 15, 2024',
      author: 'Corporate Communications',
      excerpt: 'Exploratory well encounters 180 million barrels of oil equivalent in deepwater Mozambique, marking the largest discovery in company history.',
      image: 'https://readdy.ai/api/search-image?query=Offshore%20drilling%20rig%20at%20sunset%20with%20celebration%2C%20successful%20oil%20discovery%20moment%20with%20petroleum%20engineers%2C%20professional%20industrial%20photography%20showing%20drilling%20platform%20and%20crew%2C%20golden%20hour%20lighting%20on%20ocean%2C%20historic%20discovery%20celebration&width=800&height=500&seq=news-1&orientation=landscape',
      readTime: '5 min read',
    },
    {
      title: 'Achieving Carbon Neutrality: Our Journey to Net-Zero Operations',
      category: 'Sustainability',
      date: 'March 8, 2024',
      author: 'Maria Santos, CSO',
      excerpt: 'How Alphaden achieved carbon-neutral operations seven years ahead of schedule through innovation, renewable energy integration, and carbon offset programs.',
      image: 'https://readdy.ai/api/search-image?query=Solar%20panels%20and%20wind%20turbines%20at%20oil%20facility%2C%20renewable%20energy%20integration%20at%20petroleum%20operations%2C%20professional%20photography%20showing%20sustainable%20energy%20infrastructure%2C%20green%20technology%20with%20oil%20equipment%2C%20environmental%20responsibility%20visualization&width=800&height=500&seq=news-2&orientation=landscape',
      readTime: '7 min read',
    },
    {
      title: 'AI-Powered Seismic Interpretation Reduces Exploration Risk',
      category: 'Technology',
      date: 'February 28, 2024',
      author: 'Dr. Kwame Mensah, CTO',
      excerpt: 'Proprietary machine learning algorithms improve prospect identification accuracy by 60% while cutting interpretation time in half.',
      image: 'https://readdy.ai/api/search-image?query=Geophysicist%20analyzing%20seismic%20data%20on%20multiple%20screens%20with%20AI%20visualization%2C%20petroleum%20exploration%20technology%20with%20digital%20displays%2C%20professional%20technical%20photography%20showing%20data%20analysis%2C%20modern%20operations%20center%20with%20advanced%20software%2C%20innovative%20technology&width=800&height=500&seq=news-3&orientation=landscape',
      readTime: '6 min read',
    },
    {
      title: 'Alphaden Partners with Local Communities on Education Initiative',
      category: 'Sustainability',
      date: 'February 20, 2024',
      author: 'Community Relations Team',
      excerpt: 'New STEM scholarship program will support 500 students annually in Mozambique, Kenya, and Angola, with focus on petroleum engineering and environmental science.',
      image: 'https://readdy.ai/api/search-image?query=African%20students%20in%20modern%20classroom%20with%20computers%20and%20science%20equipment%2C%20STEM%20education%20program%20with%20diverse%20young%20learners%2C%20professional%20educational%20photography%20showing%20engaged%20students%2C%20bright%20school%20environment%20with%20technology%2C%20inspiring%20learning%20atmosphere&width=800&height=500&seq=news-4&orientation=landscape',
      readTime: '4 min read',
    },
    {
      title: 'Okavango Field Expansion Exceeds Production Targets',
      category: 'Company News',
      date: 'February 12, 2024',
      author: 'Operations Team',
      excerpt: 'Enhanced oil recovery program increases production by 40%, surpassing initial projections and extending field life by 15 years.',
      image: 'https://readdy.ai/api/search-image?query=Offshore%20oil%20platform%20with%20active%20production%20operations%20at%20dusk%2C%20successful%20petroleum%20field%20with%20flare%20and%20equipment%2C%20professional%20industrial%20photography%20showing%20operational%20facility%2C%20productive%20oil%20field%20with%20lighting%2C%20operational%20excellence&width=800&height=500&seq=news-5&orientation=landscape',
      readTime: '5 min read',
    },
    {
      title: 'Digital Twin Technology Transforms Asset Management',
      category: 'Technology',
      date: 'January 30, 2024',
      author: 'Technology Team',
      excerpt: 'Virtual replicas of all production assets enable predictive maintenance, reducing unplanned downtime by 35% and cutting maintenance costs.',
      image: 'https://readdy.ai/api/search-image?query=Engineer%20viewing%20digital%20twin%20holographic%20display%20of%20oil%20facility%2C%20virtual%20reality%20petroleum%20asset%20management%2C%20professional%20technical%20photography%20showing%203D%20visualization%20technology%2C%20futuristic%20digital%20interface%20with%20facility%20model%2C%20innovative%20technology&width=800&height=500&seq=news-6&orientation=landscape',
      readTime: '6 min read',
    },
    {
      title: 'Alphaden Receives ISO 14001 Certification for Environmental Management',
      category: 'Sustainability',
      date: 'January 18, 2024',
      author: 'HSE Department',
      excerpt: 'Independent audit confirms world-class environmental management systems across all operations, reinforcing commitment to responsible development.',
      image: 'https://readdy.ai/api/search-image?query=Environmental%20audit%20team%20inspecting%20oil%20facility%20with%20pristine%20nature%2C%20petroleum%20operations%20environmental%20compliance%20inspection%2C%20professional%20documentation%20photography%20showing%20clean%20operations%2C%20inspectors%20reviewing%20environmental%20systems%2C%20certification%20excellence&width=800&height=500&seq=news-7&orientation=landscape',
      readTime: '4 min read',
    },
    {
      title: 'West African Exploration Campaign Identifies Multiple Prospects',
      category: 'Discoveries',
      date: 'January 5, 2024',
      author: 'Exploration Team',
      excerpt: '3D seismic survey across Ghana and Côte d\'Ivoire blocks reveals six high-potential prospects with combined resources exceeding 300 million barrels.',
      image: 'https://readdy.ai/api/search-image?query=Seismic%20survey%20vessel%20with%20equipment%20arrays%20in%20ocean%2C%20geophysical%20exploration%20ship%20conducting%20surveys%2C%20professional%20marine%20photography%20showing%20survey%20operations%2C%20modern%20petroleum%20exploration%20technology%20at%20sea%2C%20technical%20excellence&width=800&height=500&seq=news-8&orientation=landscape',
      readTime: '5 min read',
    },
    {
      title: 'Alphaden Named Top Employer in African Energy Sector',
      category: 'Company News',
      date: 'December 20, 2023',
      author: 'Human Resources',
      excerpt: 'Industry recognition highlights commitment to employee development, diversity, and workplace culture in annual employer rankings.',
      image: 'https://readdy.ai/api/search-image?query=Diverse%20team%20of%20happy%20petroleum%20professionals%20celebrating%20award%2C%20multicultural%20oil%20and%20gas%20employees%20in%20modern%20office%2C%20professional%20corporate%20photography%20showing%20team%20success%2C%20positive%20workplace%20culture%2C%20award%20celebration&width=800&height=500&seq=news-9&orientation=landscape',
      readTime: '3 min read',
    },
  ];

  const filteredArticles = activeCategory === 'All'
    ? articles
    : articles.filter(article => article.category === activeCategory);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section
        className="relative h-96 flex items-center justify-center text-white"
        style={{
          backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.75), rgba(15, 23, 42, 0.75)), url('https://readdy.ai/api/search-image?query=Modern%20newsroom%20with%20journalists%20and%20digital%20displays%20showing%20petroleum%20industry%20news%2C%20professional%20media%20center%20with%20multiple%20screens%2C%20contemporary%20office%20environment%20with%20news%20content%2C%20broadcast%20quality%20photography%2C%20information%20and%20communication&width=1920&height=600&seq=news-hero&orientation=landscape')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div className="relative z-10 text-center px-6">
          <h1 className="text-5xl lg:text-6xl font-bold mb-4">News & Insights</h1>
          <p className="text-xl text-gray-200 max-w-2xl mx-auto">
            Latest updates on discoveries, technology innovations, and sustainability initiatives
          </p>
        </div>
      </section>

      {/* Category Filters */}
      <section className="py-12 bg-slate-50 sticky top-16 z-40 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setActiveCategory(category)}
                className={`px-6 py-2 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category
                    ? 'bg-emerald-500 text-white shadow-lg'
                    : 'bg-white text-slate-700 hover:bg-slate-100 shadow-md'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Article */}
      {activeCategory === 'All' && (
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-6 lg:px-12">
            <div className="bg-slate-900 text-white rounded-2xl overflow-hidden shadow-2xl">
              <div className="grid lg:grid-cols-2 gap-0">
                <div
                  className="h-96 lg:h-auto bg-cover bg-center"
                  style={{
                    backgroundImage: `url('${articles[0].image}')`,
                  }}
                ></div>
                <div className="p-10 lg:p-16 flex flex-col justify-center">
                  <div className="inline-block px-4 py-2 bg-emerald-500 rounded-full text-sm font-semibold mb-6 whitespace-nowrap w-fit">
                    Featured Story
                  </div>
                  <h2 className="text-4xl font-bold mb-4">{articles[0].title}</h2>
                  <p className="text-gray-300 mb-6 text-lg leading-relaxed">{articles[0].excerpt}</p>
                  <div className="flex items-center gap-6 text-sm text-gray-400 mb-8">
                    <span>{articles[0].date}</span>
                    <span>•</span>
                    <span>{articles[0].readTime}</span>
                  </div>
                  <button className="px-8 py-3 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-colors whitespace-nowrap cursor-pointer w-fit">
                    Read Full Story
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Articles Grid */}
      <section className="py-20 lg:py-32 bg-slate-50">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.slice(activeCategory === 'All' ? 1 : 0).map((article, index) => (
              <article
                key={index}
                className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all cursor-pointer"
              >
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-56 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-4">
                    <span className={`px-3 py-1 rounded-full text-sm font-semibold whitespace-nowrap ${
                      article.category === 'Discoveries'
                        ? 'bg-purple-100 text-purple-700'
                        : article.category === 'Sustainability'
                        ? 'bg-emerald-100 text-emerald-700'
                        : article.category === 'Technology'
                        ? 'bg-blue-100 text-blue-700'
                        : 'bg-gray-100 text-gray-700'
                    }`}>
                      {article.category}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3 leading-tight">{article.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{article.excerpt}</p>
                  <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t border-slate-200">
                    <span>{article.date}</span>
                    <span>{article.readTime}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-20 bg-slate-900 text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold mb-6">
            Stay Informed
          </h2>
          <p className="text-xl text-gray-300 mb-10">
            Subscribe to our newsletter for the latest updates on discoveries, technology, and sustainability initiatives
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-2xl mx-auto">
            <input
              type="email"
              placeholder="Enter your email address"
              className="flex-1 px-6 py-4 rounded-lg text-slate-900 text-sm focus:ring-2 focus:ring-emerald-500 focus:outline-none"
              required
            />
            <button
              type="submit"
              className="px-8 py-4 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Subscribe
            </button>
          </form>
        </div>
      </section>

      <Footer />
    </div>
  );
}